import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Box, Diagram} from "../shared/Diagram"

const cellStyle = {fill: 'var(--header-text)', fontSize: 11}
const gridLineStyle = {stroke: 'var(--header-background)', opacity: 0.4}

export default function SqlVsNosql() {
    return (
        <TopicLayout
            title="SQL vs. NoSQL"
            intro="A fixed, shared schema that every row conforms to versus a model where each record can carry its own shape. The right choice follows from the data's relationships and how it will be queried, not familiarity."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>SQL — fixed schema</text>
                    <rect x={40} y={28} width={200} height={130} rx={4}
                          style={{fill: 'var(--header-text)', stroke: 'var(--header-background)', strokeWidth: 1.5}}/>
                    <rect x={40} y={28} width={200} height={32.5} rx={4}
                          style={{fill: 'var(--header-background)'}}/>
                    <text x={73} y={48} textAnchor="middle" style={cellStyle}>id</text>
                    <text x={140} y={48} textAnchor="middle" style={cellStyle}>name</text>
                    <text x={207} y={48} textAnchor="middle" style={cellStyle}>email</text>
                    <line x1={106.7} y1={28} x2={106.7} y2={158} style={gridLineStyle}/>
                    <line x1={173.4} y1={28} x2={173.4} y2={158} style={gridLineStyle}/>
                    <line x1={40} y1={93} x2={240} y2={93} style={gridLineStyle}/>
                    <line x1={40} y1={125.5} x2={240} y2={125.5} style={gridLineStyle}/>
                    <text x={140} y={82} textAnchor="middle" style={{fill: 'var(--p-color)', fontSize: 11, opacity: 0.6}}>···  ···  ···</text>
                    <text x={140} y={114} textAnchor="middle" style={{fill: 'var(--p-color)', fontSize: 11, opacity: 0.6}}>···  ···  ···</text>

                    <line x1={300} y1={10} x2={300} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={440} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>NoSQL — per-record shape</text>
                    <Box x={350} y={30} width={170} height={40} label="{ id, name }"/>
                    <Box x={335} y={80} width={170} height={40} label="{ id, tags }"/>
                    <Box x={365} y={130} width={170} height={40} label="{ id, email }"/>
                </Diagram>
            }
            useWhen={[
                'SQL: data has clear relationships, multi-row transactions matter, or query patterns include joins and ad-hoc reporting.',
                'NoSQL: data and access patterns naturally fit a particular model, such as key-value or document access, or measured requirements call for a database with a suitable distribution model.'
            ]}
            tradeOff="Relational databases provide mature transactions and flexible querying, while horizontal write scaling can require partitioning and careful design. NoSQL is a family of systems, not one consistency model: transaction support, consistency, query flexibility and scaling behavior vary by product. Denormalization can move joins and integrity work into application code."
            ruleOfThumb="Start with SQL unless a proven access pattern, data model or scale requirement points to a specific alternative; first check indexing, caching, read replicas and partitioning."
        />
    )
}
